import { render } from "./SelectCheckboxMinOne.vue?vue&type=template&id=5592a0f4"
import script from "./SelectCheckboxMinOne.vue?vue&type=script&lang=js"
export * from "./SelectCheckboxMinOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__